// extracted by mini-css-extract-plugin
export default {"root":"PlasmicCrypto_root__dnwrL","text":"PlasmicCrypto_text__mpUFi"};